import { Alert } from 'antd';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { EUpozorneni } from 'enums/statniSprava/upozorneni';

interface IAlertComponent {
    upozorneni: EUpozorneni[];
    type: 'warning' | 'success' | 'info' | 'error';
}

const AlertComponent: React.FC<IAlertComponent> = ({ upozorneni, type }) => (
    <>
        {upozorneni.map((e, i) => (
            <Alert
                key={i}
                message={<TranslateText>{`UPOZORNENI_${e}`}</TranslateText>}
                // description={<TranslateText>{`DUVERNE_INFO_WARNING_${e}`}</TranslateText>}
                type={type}
                style={{
                    marginTop: 10,
                    marginBottom: 16
                }}
            />
        ))}
    </>
);

export default AlertComponent;
